import 'component/adaptive-video'

class HHVideoHero extends HTMLElement {
  constructor() {
    super()

    this.audioButton?.addEventListener(
      'click',
      this.onClickAudioButton.bind(this)
    )
  }

  onClickAudioButton() {
    const mutted = this.audioButton.getAttribute('data-mode') == 'mute'
    const targetMode = mutted ? 'play' : 'mute'
    this.audioButton.setAttribute('data-mode', targetMode)
    this.audioIcons.forEach((icon) => {
      const mode = icon.getAttribute('data-mode')
      if (mode == targetMode) {
        icon.classList.remove('hidden')
      } else {
        icon.classList.add('hidden')
      }
    })
    this.videoElement?.handleToggleAudio()
  }

  get videoElement() {
    return this.querySelector('hh-adaptive-video')
  }

  get audioButton() {
    return this.querySelector('.js-audio-button')
  }

  get audioIcons() {
    return this.querySelectorAll('.js-audio-icon')
  }
}

if (!customElements.get('hh-video-hero')) {
  customElements.define('hh-video-hero', HHVideoHero)
}
